import { ChevronRightIcon } from '@heroicons/react/24/outline'
import { ButtonLink } from './ButtonLink'
import ctaGrain from '@/images/cta-grain.png'
import Image from 'next/image'
import { bookDemoLink, signupLink } from '@/config'

export default function CTASection() {
  return (
    <section className="relative flex w-full flex-col items-center gap-20 overflow-hidden px-5 py-20 sm:px-10 xl:px-[100px] xl:py-[112px]">
      <div className="bg-cta-radial absolute -top-0 left-0 right-0 -z-20 mx-auto h-full w-[700px] opacity-70 sm:w-full lg:-top-32 lg:h-[706.304px]" />
      <Image
        src={ctaGrain}
        alt="grain"
        className="absolute bottom-0 -z-10 h-full w-full xl:top-0 xl:min-h-[542px]"
      />

      <div className="flex w-full flex-col items-center gap-5">
        <h2 className="w-full text-center text-[36px] font-medium !leading-[130%] tracking-[-0.48px] lg:max-w-[548px] xl:text-5xl">
          Get up and running in less than 15 minutes
        </h2>
        <p className="w-full text-center text-base leading-[150%] tracking-[-0.18px] text-white/80 lg:w-[472px] xl:text-lg">
          Connect your Snowflake account and instantly understand your savings
          potential.
        </p>

        <div className="custom-xs:flex-row mt-5 flex flex-col items-center justify-center gap-4">
          <ButtonLink
            target="_blank"
            href={bookDemoLink}
            variant="primary"
            size="lg"
            className="rounded-xl"
            aria-label="Book a Demo"
          >
            Book a Demo
          </ButtonLink>

          <ButtonLink href={signupLink} size="lg">
            <span className="text-base">Start Free Trial</span>
            <ChevronRightIcon className="-ml-1 h-3 w-3 stroke-2 text-white transition-colors duration-300 group-hover:text-[#38BDF9]" />
          </ButtonLink>
        </div>
      </div>
    </section>
  )
}
